import React from 'react';
import ListaIntegrantes from '../../components/SobreNosComponents/ListaIntegrantes.js';
import ImagemSobre from '../../assets/images/sobre-imge-text.jpeg';
import './Sobre.css'
import backgroundImage from '../../assets/ImgFundo/FundoFaleConosco.jpg'; // Importe a imagem diretamente
import backgroundImageA from '../../assets/images/fundo-SobreBanco.jpg'; // Importe a imagem diretamente

import { 
  Container, 
  Typography, 
  Grid, 
  Box,
  CardMedia,
  Card 
} from '@mui/material';

export default function Sobre() {
  return (
    
     <>
      
      <Box className="TituloSobre">
      <Typography
             variant="h1"
             align="center"
             gutterBottom
             style={{
               fontFamily: "'Lato', serif",
               color: "white",
               borderBottom: "4px solid #d4af37",
               paddingBottom: "10px",
               textTransform: "uppercase",
               animation: "glow 2s infinite alternate",
               marginTop: "7%"  // Aqui é onde você define o espaço superior
             }}
           > 
          Uma história da Península
        </Typography>
         
      </Box>

      <Box 
      sx={{ 
        py: 8, 
        backgroundColor: '#f0f0f0', 
        backgroundImage: `url(${backgroundImage})`, 
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <Container sx={{ py: 6 }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
          <Typography
             variant="h1"
             align="center"
             gutterBottom
             style={{
               fontFamily: "'Lato', serif",
               color: "#800020",
               borderBottom: "4px solid #d4af37",
               paddingBottom: "10px",
               textTransform: "uppercase",
               animation: "glow 2s infinite alternate",
               textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
               marginTop: "7%"  // Aqui é onde você define o espaço superior
             }}
           > 
              Sobre o Grupo
            </Typography>
            <Typography 
                variant="body1" 
                color="textSecondary" 
                sx={{ fontFamily: 'Georgia, serif' }} // Define uma fonte serifada para combinar com o tema histórico
              >
              O grupo “O ensino da fé cristã na Península Ibérica (sécs. XIV, XV e XVI)” foi criado com a
              finalidade de explorar os caminhos percorridos pela cúpula da Igreja para a fixação das
              crenças católicas no reino de Portugal e na Coroa de Castela no final da Idade Média e
              início dos tempos modernos.
            </Typography>
            <Typography 
                variant="body1" 
                color="textSecondary" 
                sx={{ fontFamily: 'Georgia, serif' }} // Define uma fonte serifada para combinar com o tema histórico
              >
              Financiado pelo auxílio Jovem Pesquisador da FAPESP (Processo 2017/11111-9) e sediado na
              Universidade Estadual de Campinas, o projeto visa serializar a produção de escritos doutrinários 
              e místicos de Portugal e Castela.
            </Typography>
          </Grid>
        
<Grid item xs={12} md={6}>
  <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
    <CardMedia
      component="img"
      image={ImagemSobre}
      alt="Sobre o grupo"
      sx={{ width: "100%", borderRadius: 2 }}
    />
  </Card>
</Grid>;
        </Grid>
      </Container>
      </Box>
      
  
 
   
    <Box
      sx={{
        py: 8,
        backgroundColor: '#f0f0f0',
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${backgroundImageA})`, // Overlay escuro
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        color: 'white',
      }}
    >
      <Container>
        <Typography
          variant="h3"
          align="center"
          gutterBottom
          sx={{
            fontFamily: "'Lato', sans-serif",
            fontWeight: 'bold',
            color: 'white',
            borderBottom: '4px solid #d4af37',
            paddingBottom: '10px',
            textTransform: 'uppercase',
            animation: 'glow 2s infinite alternate',
            marginTop: '7%',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',

            fontSize: { xs: '2rem', md: '3rem' }, // Responsivo
          }}
        >
          Banco de Dados
        </Typography>
        <Typography
          variant="h6"
          textAlign="center"
          gutterBottom
          sx={{
            color: '#fbfbfb',
            fontSize: { xs: '1rem', md: '1.25rem' }, // Responsivo
            fontFamily: "'Lato', sans-serif",
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',

            mb: 4,
          }}
        >
          Obras pastorais e doutrinárias do mundo ibérico
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)', // Fundo semi-transparente
                borderRadius: '16px', // Bordas arredondadas
                padding: '24px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)', // Sombra
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.02)', // Efeito de zoom suave
                },
              }}
            >
              <Typography
                variant="h5"
                fontWeight="bold"
                gutterBottom
                sx={{ fontSize: '1.5rem', color: '#ffffff', mb: 2 }}
              >
                Objetivo
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: 'white',
                  fontFamily: "'Merriweather', serif", // Fonte serifada moderna
                  lineHeight: '1.8',
                }}
              >
                O grupo “O ensino da fé cristã na Península Ibérica (sécs. XIV, XV e XVI)” foi criado com a finalidade de explorar os caminhos percorridos pela cúpula da Igreja para a fixação das crenças católicas no reino de Portugal e na Coroa de Castela no final da Idade Média e início dos tempos modernos. Envolvendo pesquisadores de diferentes universidades brasileiras e do exterior, esse projeto investirá na organização de cursos específicos acerca dessa temática, de eventos científicos e na criação de um banco de dados de obras pastorais.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)', // Fundo semi-transparente
                borderRadius: '16px', // Bordas arredondadas
                padding: '24px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)', // Sombra
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.02)', // Efeito de zoom suave
                },
              }}
            >
              <Typography
                variant="h5"
                fontWeight="bold"
                gutterBottom
                sx={{ fontSize: '1.5rem', color: '#ffffff', mb: 2 }}
              >
                Estrutura
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: 'white',
                  fontFamily: "'Merriweather', serif", // Fonte serifada moderna
                  lineHeight: '1.8',
                }}
              >
                Financiado pelo auxílio Jovem Pesquisador da FAPESP (Processo 2017/11111-9) e sediado na Universidade Estadual de Campinas, o projeto visa serializar a produção de escritos doutrinários e místicos de Portugal e Castela e estimular desde o trabalho de edição de fontes medievais e modernas até a elaboração de estudos dos modos do fazer crer, isto é, dos jogos de ensino e aprendizagem da moral cristã.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  

      <ListaIntegrantes />

      <Container sx={{ py: 4 }}>
       
      </Container>

      
    </>
  );
}
